import authInstance from 'config/axios.config';

export const propertyAttributeServices = {
  uploadFile: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    const res = await authInstance.post('/admin/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return res.data;
  },

  getPropertyAttributes: async (filters) => {
    const params = new URLSearchParams();

    Object.entries(filters || {}).forEach(([key, value]) => {
      if (value && value !== 'all') {
        params.append(key, String(value));
      }
    });

    const res = await authInstance.get(`/property/admin/attributes?${params}`);
    return res.data;
  },

  addPropertyAttribute: async (payload) => {
    const res = await authInstance.post('/property/admin/attributes', payload);
    return res.data;
  },

  updatePropertyAttribute: async ({ id, data }) => {
    const res = await authInstance.patch(`/property/admin/attributes/${id}`, data);
    return res.data;
  },

  deletePropertyAttribute: async (id) => {
    const res = await authInstance.delete(`/property/admin/attributes/${id}`);
    return res.data;
  },
};
